/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FRUser, TokenManager, UserManager } from '@forgerock/javascript-sdk';
import { Route, useNavigate, Navigate, Outlet, BrowserRouter, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { isLoggedInSelector, setUser, toggleLogin } from '../../redux/loginSlice';
import AppAuthHelper from '../../appauthhelper/appAuthHelperCompat';
import SessionCheck from 'oidcsessioncheck';
import { configOptions, idmConfigOptions } from '../../config';
import  debounce  from 'lodash/debounce';
import { useEffect, useLayoutEffect, useState } from 'react';

import Loading from '../02-molecules/Loading';
import { amRequest } from '../../lib/idmRequest';
import IndexedDb from '../../util/indexdbb';
import LeftNavSection from './NavBarSections/LeftNavSection';
import styles from '../../styles/Home.module.css';

export function AuthLayout(): JSX.Element {

  const [isAuth, setIsAuthN] = useState<boolean>();
  const navigate = useNavigate();
  const { isLoggedIn, user } = useAppSelector(isLoggedInSelector);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [sessionCheckGlobal, setSessionCheckGlobal] = useState<any>()


  const AM_URL = configOptions.serverConfig.baseUrl
  const windowObject: any = window;
  const realmPath = 'realms/root/realms/PnW/'
  const resourceServers = {
    [idmConfigOptions.baseUrl]: 'fr:idm:* profile email',
  };
  let sessionCheck: any;

  function parseSub(claims: any) {
    const subParts = claims.sub.match(/^\((\w{3})!(.+)\)$/);
    let sub;
    if (subParts) {
      // eslint-disable-next-line prefer-destructuring
      sub = subParts[2];
    } else {
      sub = claims.sub;
    }
    return sub;
  }



  let postLogoutUrlClaim: any;
  let clickSession: any;
  let keypressSession: any;
  let pageFocus: any;
  let debounceVar: any;
  const clientId = configOptions.clientId;
  // const clientId ='end-user-ui'
  const configData = {
    clientId: clientId,
    authorizationEndpoint: `${configOptions.serverConfig.baseUrl}oauth2/${realmPath}authorize`,
    tokenEndpoint: `${AM_URL}oauth2/${realmPath}access_token`,
    revocationEndpoint: `${AM_URL}oauth2/${realmPath}token/revoke`,
    endSessionEndpoint: `${AM_URL}oauth2/${realmPath}connect/endSession`,
    identityProxyPreference: 'XHR',
    resourceServers,
    tokensAvailableHandler(claims: any, id_token: any) {
      console.log('token Available handler called')
      console.log(id_token)
      const request = window.indexedDB.open('appAuth');
      let db;
      request.onsuccess = (ev => {
 
        db = request.result;
        const transaction = db.transaction(["dashboardAppClient"], "readwrite");
        transaction.oncomplete = (ev) => {

        }
        const store = transaction.objectStore("dashboardAppClient");
        const result = store.getAll();
        result.onsuccess = (ev) => {
   
          console.log("result" + result)
          localStorage.setItem("forgerock-sdk-dashboardAppClient", JSON.stringify(result.result[0]))
          const myHeaders = new Headers();

          myHeaders.append('Authorization', 'Bearer ' + result.result[0]['accessToken']);
          amRequest('oauth2/realms/root/realms/PnW/userinfo').then(res => {
            console.log('calling userInfo')
            const userInfo = res;
            dispatch(setUser(userInfo))
            bool = !!(userInfo);
            setIsAuthN(bool);
            dispatch(toggleLogin(true));
            var script = document.createElement('script')
            script.type = "text/javascript"
            script.id = "walkmeSnippet"
            script.innerHTML = `(function() {var walkme = document.createElement('script'); walkme.type = 'text/javascript'; walkme.async = true; walkme.src = ${configOptions.walkMeURL} var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(walkme, s); window._walkmeConfig = {smartLoad:true}; })();`
            document.head.appendChild(script);
          }).catch((e) => {
            console.log('failed to get user details')
     
            // navigate('/login?redirectUi='+location.pathname)
            bool = false;
            setIsAuthN(false)
          })

        }

        console.log(request)
        let version = db.version;
        db.close();
 
        var secReq = indexedDB.open('appAuth',version+1)
        secReq.onupgradeneeded = function (e : any) {
   
              var database = e.target?.result;
              if (!database.objectStoreNames.contains('end-user-ui')){
                // co1=db.createObjectStore('iam');
                var objectStore = database.createObjectStore("end-user-ui");
            };
          };
      })

      const sub = parseSub(claims);
      postLogoutUrlClaim = claims.post_logout_url;

      let bool: boolean = false;
      sessionCheck = new SessionCheck({
        clientId: clientId,
        opUrl: `${configOptions.serverConfig.baseUrl}oauth2/${realmPath}authorize`,
        subject: claims.sub,

        invalidSessionHandler(reason: any) {
          console.log(reason)
          /**
          * If the reason for the invalid session is a subject_mismatch we always want to
          * reload the page after logout whether there is a post_logout_url claim or not.
          */
          windowObject.logout(false, reason !== 'subject_mismatch');
          let scripttag = document.getElementById("walkmeSnippet")
          if (scripttag) {
            scripttag?.parentNode?.removeChild(scripttag);
          }
        },
        sessionClaimsHandler(newClaims: any) {
          console.log(newClaims)
          if (claims.auth_time !== newClaims.auth_time || claims.realm !== newClaims.realm) {
            windowObject.logout(false);
            let scripttag = document.getElementById("walkmeSnippet")
            if (scripttag) {
              scripttag?.parentNode?.removeChild(scripttag);
            }
          }
          /**
           * Check that the originalLoginRealm session variable is set.
           * If not set it so we know what realm to use for logout.
           */
          if (!sessionStorage.getItem('originalLoginRealm')) {
            sessionStorage.setItem('originalLoginRealm', 'PnW');
          }
        },
        cooldownPeriod: 5,
      });
      setSessionCheckGlobal(sessionCheck)
    }
  }

  useEffect(() => {
    if (!!sessionCheckGlobal) {

      const triggerSession = () => {
        sessionCheckGlobal?.triggerSessionCheck();
      };
      sessionCheckGlobal.triggerSessionCheck();
      debounceVar = debounce(triggerSession, 100)
      document.removeEventListener('click', clickSession);
      clickSession = document.addEventListener('click', debounceVar);
      document.removeEventListener('keypress', keypressSession);
      keypressSession = document.addEventListener('keypress', debounceVar);
      document.removeEventListener('focusin', pageFocus);
      pageFocus = document.addEventListener('focusin', debounceVar);
    }
  }, [sessionCheckGlobal])
  

  windowObject.logout = (clearHash = true, invalidSession = false) => {
    const loginRealm = sessionStorage.getItem('originalLoginRealm');

    window.removeEventListener('click', debounceVar);
    window.removeEventListener('keypress', debounceVar);
    window.removeEventListener('focusin', debounceVar);
    /**
     * If there is an originalLoginRealm and that realm is different from the current realm
     * we need to set store.state.realm to it's original state so we can log out properly.
     */
    if (loginRealm && configOptions.realmPath !== loginRealm) {
      //store.commit('setRealm', loginRealm);
      sessionStorage.removeItem('originalLoginRealm');
    }
    // clear hash so user is not directed to previous hash on subsequent logins
    if (clearHash) window.location.hash = '';

    sessionStorage.removeItem('mfacode');
    sessionStorage.removeItem('mfastate');
    sessionStorage.removeItem('step');
    AppAuthHelper.logout().then(() => {
      sessionCheckGlobal.destroy();
      AppAuthHelper.destroy();
      dispatch(toggleLogin(false))
      let scripttag = document.getElementById("walkmeSnippet")
      if (scripttag) {
        scripttag?.parentNode?.removeChild(scripttag);
      }
      if (postLogoutUrlClaim && (clearHash || invalidSession)) {
        window.location.href = postLogoutUrlClaim;
      } else {
        if(!!location.search) {
          navigate('/login?redirectUi=' + location.pathname + location.search)
        } else {
          navigate('/login?redirectUi=' + location.pathname)
        }
      }
    });
  }

  useEffect(() => {
     AppAuthHelper.init(configData).then(() => {

      AppAuthHelper.getTokens();
    }) 
  }, [])





  return (

    isAuth === undefined || !isAuth ?
      <main >
        <Loading size={100} />
      </main>
      :
      <div>
        <div className='Basecontainer' style={{ top: '0px',bottom:'0px' }} >
          <main className='Basemain'>
            <LeftNavSection />
            <div className={styles.protectedContainer}>
             <Outlet/>
            </div>
          </main>
        </div>
      </div >


  );
}

